import React from 'react';
import { connect } from 'react-redux';

import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { Location } from '../../../common/react/Location';
import { VizPathInitialState } from '../../reducers/VizPathReducer';
import { selectVizPath } from '../../selectors/VizPathSelector';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { ConnectedRevisionHistorySpaceProvider, getRevisionHistoryVizPath, RevisionHistoryInfo, RevisionHistorySpaceProviderOwnProps } from './RevisionHistorySpaceProvider';

// we don't care about the item for this space because nothing in redux uses it for this space
const revisionSpaceInfo: SpaceInfo = { spaceType: 'revisionhistory', subspaceName: undefined, item: SpaceItemForNonEntitySpace};

export namespace RevisionHistorySpaceUrlUpdater {
  export interface OwnProps {
    readonly urls: SpacesSiteUrls;
    readonly revisionHistoryInfo: RevisionHistoryInfo;
    readonly routeLocationSearch: string;
    readonly renderProvider: (props: ContainerProps) => JSX.Element;
  }

  interface StateProps {
    readonly vizPath: string;
  }

  export type ContainerProps = OwnProps & StateProps;

  export class Container extends React.PureComponent<ContainerProps> {
    public render() {
      return this.props.renderProvider(this.props);
    }

    public componentDidUpdate(prevProps: ContainerProps) {
      const vizPathFromUrl = getRevisionHistoryVizPath(this.props.revisionHistoryInfo);
      if (this.props.vizPath !== VizPathInitialState &&
        this.props.vizPath !== prevProps.vizPath &&
        this.props.vizPath !== vizPathFromUrl) {
        // vizPath changed via user clicking on viz tab (that's why the url viz path does not match the previous app state vizPath-- see tbViz),
        // so update the url
        const newVizPathSplitOnSlash = this.props.vizPath.split('/');

        // the vizPath is workbookUrlId/sheetUrlId/history/4 where 4 is the revision number
        const newWorkbookUrlId = newVizPathSplitOnSlash[0];
        const newSheetUrlId = newVizPathSplitOnSlash[1];

        if (newSheetUrlId && this.props.revisionHistoryInfo.sheetUrlId) {
          // url only needs updating if the sheet is in the url
          const newRevisionNumber = newVizPathSplitOnSlash[3];

          // routeLocationSearch already includes the ? so just add it to keep the search parameters
          Location.instance.setUrl(this.props.urls.workbookRevisionHistorySpecificSheetUrl({
            workbookUrlId: newWorkbookUrlId,
            revisionNumber: newRevisionNumber,
            sheetUrlId: newSheetUrlId
          }) + this.props.routeLocationSearch);
        }
      }
    }
  }

  const mapStateToProps: MapStateToProps<StateProps> = (appState) => ({
    vizPath: selectVizPath(appState),
  });

  export const ConnectedContainer: React.ComponentClass<OwnProps>
    = connect(mapStateToProps)(Container);

  export const renderProvider = (props: ContainerProps) => {
    const renderRevisionHistorySpaceProps: RevisionHistorySpaceProviderOwnProps = {
      revisionHistoryInfo: props.revisionHistoryInfo,
      routeLocationSearch: props.routeLocationSearch,
      urls: props.urls,
    };

    return (<ConnectedSpaceInfoProvider spaceInfo={revisionSpaceInfo}>
      <ConnectedRevisionHistorySpaceProvider {...renderRevisionHistorySpaceProps} />
    </ConnectedSpaceInfoProvider>);
  };
}
